import { useNavigate } from 'react-router';

import { X } from '../assets';
import {
  FAVICON_LOGO_PATH,
  ROUTES,
  closeModal,
  openModal,
  useUIStore,
} from '../lib';
import { BackLink } from './back-link';
import { ResetModal } from './modals/reset-modal';

export const CustomizeCloseButton: React.FC<{ isLogo?: boolean }> = ({
  isLogo,
}) => {
  const show = useUIStore((state) => state.showCustomizeBackButton);
  const isChanged = useUIStore((state) => state.isChanged);
  const setIsChanged = useUIStore((state) => state.setIsChanged);
  const navigate = useNavigate();
  const handleClick = async () => {
    if (isChanged) {
      openModal({
        id: 'reset-modal',
        component: () => (
          <ResetModal
            onCancel={() => {
              closeModal('reset-modal');
            }}
            onConfirm={async () => {
              setIsChanged(false);
              if (isLogo) {
                await navigate(ROUTES.ROOT);
              } else {
                await navigate(-1);
              }

              closeModal('reset-modal');
            }}
          />
        ),
      });
    } else {
      if (isLogo) {
        await navigate(ROUTES.ROOT);
      } else {
        await navigate(-1);
      }
    }
  };

  if (!show) return null;

  return isLogo ? (
    <button className="z-50" onClick={handleClick}>
      <img
        src={FAVICON_LOGO_PATH}
        alt="logo"
        className="aspect-square w-12 cursor-pointer"
      />
    </button>
  ) : (
    <BackLink
      className="ml-auto"
      icon={<X className="min-h-5 min-w-5" />}
      onClick={handleClick}
    />
  );
};
